<div class="container bg-header" style="background-color: rgb(105, 69, 175) !important;">
  <div class="row">
    <div class="col-8">
      <h1 mat-dialog-title class="text-white p-3 m-0" style="color: white !important;">
        {{ 'modals.select-inputs.title' | translate }}
      </h1>
    </div>
    <div class="col-4 d-flex justify-content-end align-items-center">
      <p role="button" (click)="closeModal()" class="text-white m-0">{{ 'generic.buttons.cancel' | translate }}</p>
      <mat-icon class="ml-1" (click)="closeModal()">cancel</mat-icon>
    </div>
  </div>
</div>

<div mat-dialog-content class="m-3">
  <div class="container">
    <!-- Selected Inputs Summary -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
          <span class="badge badge-info">
            {{ selectedInputs.length }}
            {{ selectedInputs.length === 1 ? ('modals.select-inputs.input-selected' | translate) : ('modals.select-inputs.inputs-selected' | translate) }}
          </span>
        </div>
      </div>
    </div>

    <!-- Input Type Tabs -->
    <div class="row">
      <div class="col-12">
        <mat-tab-group [(selectedIndex)]="activeTabIndex" (selectedTabChange)="onTabChange($event)">

          <!-- SURVEY TAB -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="mr-2">poll</mat-icon>
              {{ 'modals.select-inputs.tabs.surveys' | translate }}
            </ng-template>

            <div class="tab-content p-3">
              @if (loadingSurveys) {
                <div class="text-center py-4">
                  <mat-spinner diameter="40"></mat-spinner>
                  <p class="mt-2">{{ 'generic.loading' | translate }}</p>
                </div>
              }

              @if (!loadingSurveys && availableSurveys.length === 0) {
                <div class="text-center py-4">
                  <mat-icon style="font-size: 3rem; color: #ccc;">poll</mat-icon>
                  <p class="text-muted mt-2">{{ 'modals.select-inputs.no-surveys' | translate }}</p>
                </div>
              }

              @if (!loadingSurveys && availableSurveys.length > 0) {
                <div>
                  @for (survey of availableSurveys; track survey) {
                    <div
                      class="input-item"
                      [class.selected]="selectedSurveys.has(survey.id)"
                      (click)="toggleSurveySelection(survey.id)">
                      <mat-checkbox [checked]="selectedSurveys.has(survey.id)" (click)="$event.stopPropagation()"></mat-checkbox>
                      <mat-icon class="mx-2">poll</mat-icon>
                      <div class="flex-grow-1">
                        <div class="input-name">{{ survey.title }}</div>
                        <div class="input-meta">
                          @if (survey.members) {
                            <span>{{ survey.members.length }} {{ 'modals.select-inputs.participants' | translate }}</span>
                          }
                          @if (survey.questions_count) {
                            <span class="ml-2">{{ survey.questions_count }} {{ 'modals.select-inputs.questions' | translate }}</span>
                          }
                          <span class="badge ml-2" [ngClass]="getCompletionBadgeClass(survey)">
                            {{ getCompletionPercentage(survey) }}% {{ 'modals.select-inputs.completion' | translate }}
                          </span>
                          <span class="ml-2 text-muted">{{ survey.updated_at | date:'dd/MM/yyyy' }}</span>
                        </div>
                      </div>
                      <button mat-icon-button (click)="viewSurveyDetails(survey.id, $event)" class="ml-2">
                        <mat-icon>visibility</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </mat-tab>

          <!-- PDF TAB -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="mr-2">picture_as_pdf</mat-icon>
              {{ 'modals.select-inputs.tabs.pdf' | translate }}
            </ng-template>

            <div class="tab-content p-3">
              <div class="mb-3">
                <input type="file"
                  #fileInput
                  accept="application/pdf"
                  multiple
                  style="display: none"
                  (change)="onFileSelected($event)">
                <button mat-raised-button color="primary" (click)="fileInput.click()" [disabled]="uploadingPDF">
                  <mat-icon>upload</mat-icon>
                  {{ 'modals.select-inputs.upload-pdf' | translate }}
                </button>
              </div>

              @if (uploadingPDF) {
                <div class="mb-3">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                  <p class="text-center mt-2">{{ 'modals.select-inputs.uploading' | translate }}</p>
                </div>
              }

              <!-- Loading state -->
              @if (loadingPDFs) {
                <div class="text-center py-4">
                  <mat-spinner diameter="40"></mat-spinner>
                  <p class="mt-2">{{ 'generic.loading' | translate }}</p>
                </div>
              }

              <!-- Stored PDFs from database -->
              @if (!loadingPDFs && storedPDFs.length > 0) {
                <div>
                  <h4 class="mb-3">{{ 'modals.select-inputs.stored-pdfs' | translate }}</h4>
                  @for (pdf of storedPDFs; track pdf) {
                    <div
                      class="input-item"
                      [class.selected]="selectedPDFs.has(pdf.id)"
                      (click)="toggleStoredPDFSelection(pdf.id)">
                      <mat-checkbox [checked]="selectedPDFs.has(pdf.id)" (click)="$event.stopPropagation()"></mat-checkbox>
                      <mat-icon class="mx-2 text-danger">picture_as_pdf</mat-icon>
                      <div class="flex-grow-1">
                        <div class="input-name">{{ pdf.file_name }}</div>
                        <div class="input-meta">
                          <span>{{ formatFileSize(pdf.file_size) }}</span>
                          @if (pdf.pages_count) {
                            <span class="ml-2 text-muted">{{ pdf.pages_count }} {{ 'modals.select-inputs.pages' | translate }}</span>
                          }
                          <span class="ml-2 text-muted">{{ pdf.upload_date | date:'dd/MM/yyyy' }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }

              <!-- Newly uploaded PDFs -->
              @if (uploadedPDFs.length > 0) {
                <div class="mt-3">
                  <h4 class="mb-3">{{ 'modals.select-inputs.newly-uploaded' | translate }}</h4>
                  @for (pdf of uploadedPDFs; track pdf; let i = $index) {
                    <div class="input-item selected">
                      <mat-icon class="mx-2 text-danger">picture_as_pdf</mat-icon>
                      <div class="flex-grow-1">
                        <div class="input-name">{{ pdf.name }}</div>
                        <div class="input-meta">{{ pdf.metadata?.size }}</div>
                      </div>
                      <button mat-icon-button (click)="removePDF(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              }

              <!-- Empty state -->
              @if (!loadingPDFs && storedPDFs.length === 0 && uploadedPDFs.length === 0 && !uploadingPDF) {
                <div class="text-center py-4">
                  <mat-icon style="font-size: 3rem; color: #ccc;">picture_as_pdf</mat-icon>
                  <p class="text-muted mt-2">{{ 'modals.select-inputs.no-pdfs' | translate }}</p>
                </div>
              }
            </div>
          </mat-tab>

          <!-- PUBMED TAB -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="mr-2">article</mat-icon>
              {{ 'modals.select-inputs.tabs.pubmed' | translate }}
            </ng-template>

            <div class="tab-content p-3">
              <!-- Add PubMed Article Button -->
              <div class="mb-3">
                <button mat-raised-button color="primary" (click)="openPubMedAttachmentModal()">
                  <mat-icon>add</mat-icon>
                  {{ 'modals.select-inputs.add-pubmed-article' | translate }}
                </button>
              </div>

              <!-- Loading state -->
              @if (loadingPubMedDocs) {
                <div class="text-center py-4">
                  <mat-spinner diameter="40"></mat-spinner>
                  <p class="mt-2">{{ 'generic.loading' | translate }}</p>
                </div>
              }

              <!-- Stored PubMed documents from database -->
              @if (!loadingPubMedDocs && storedPubMedDocs.length > 0) {
                <div>
                  <h4 class="mb-3">{{ 'modals.select-inputs.stored-pubmed' | translate }}</h4>
                  @for (doc of storedPubMedDocs; track doc) {
                    <div
                      class="input-item"
                      [class.selected]="selectedPubMedIds.has(doc.pmid)"
                      (click)="toggleStoredPubMedSelection(doc.id)">
                      <mat-checkbox [checked]="selectedPubMedIds.has(doc.pmid)" (click)="$event.stopPropagation()"></mat-checkbox>
                      <mat-icon class="mx-2 text-success">article</mat-icon>
                      <div class="flex-grow-1">
                        <div class="input-name">{{ doc.title }}</div>
                        <div class="input-meta">
                          @if (doc.authors) {
                            <span>{{ doc.authors }}</span>
                          }
                          @if (doc.year) {
                            <span class="ml-2">{{ doc.year }}</span>
                          }
                          <span class="ml-2">PMID: {{ doc.pmid }}</span>
                          <span class="ml-2 text-muted">{{ doc.added_at | date:'dd/MM/yyyy' }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }

              <!-- Empty state -->
              @if (!loadingPubMedDocs && storedPubMedDocs.length === 0) {
                <div class="text-center py-4">
                  <mat-icon style="font-size: 3rem; color: #ccc;">article</mat-icon>
                  <p class="text-muted mt-2">{{ 'modals.select-inputs.no-pubmed-documents' | translate }}</p>
                </div>
              }
            </div>
          </mat-tab>

          <!-- LITERATURE REVIEW TAB -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="mr-2">library_books</mat-icon>
              {{ 'modals.select-inputs.tabs.literature-review' | translate }}
            </ng-template>

            <div class="tab-content p-3">
              @if (loadingLiteratureReviews) {
                <div class="text-center py-4">
                  <mat-spinner diameter="40"></mat-spinner>
                  <p class="mt-2">{{ 'generic.loading' | translate }}</p>
                </div>
              }

              @if (!loadingLiteratureReviews && availableLiteratureReviews.length === 0) {
                <div class="text-center py-4">
                  <mat-icon style="font-size: 3rem; color: #ccc;">library_books</mat-icon>
                  <p class="text-muted mt-2">{{ 'modals.select-inputs.no-literature-reviews' | translate }}</p>
                </div>
              }

              @if (!loadingLiteratureReviews && availableLiteratureReviews.length > 0) {
                <div>
                  @for (review of availableLiteratureReviews; track review) {
                    <div
                      class="input-item"
                      [class.selected]="selectedLiteratureReviews.has(review.id)"
                      (click)="toggleLiteratureReviewSelection(review.id)">
                      <mat-checkbox [checked]="selectedLiteratureReviews.has(review.id)" (click)="$event.stopPropagation()"></mat-checkbox>
                      <mat-icon class="mx-2">library_books</mat-icon>
                      <div class="flex-grow-1">
                        <div class="input-name">{{ review.title }}</div>
                        <div class="input-meta">
                          @if (review.documents_count) {
                            <span>
                              {{ review.documents_count }} {{ 'modals.select-inputs.documents' | translate }}
                            </span>
                          }
                          @if (review.overall_quality) {
                            <span class="badge ml-2" [ngClass]="getQualityBadgeClass(review.overall_quality)">
                              {{ review.overall_quality | uppercase }} {{ 'modals.select-inputs.quality' | translate }}
                            </span>
                          }
                          @if (review.pico_question) {
                            <span class="ml-2 text-muted">
                              <mat-icon class="small-icon">psychology</mat-icon> PICO
                            </span>
                          }
                          <span class="ml-2 text-muted">{{ review.updated_at | date:'dd/MM/yyyy' }}</span>
                        </div>
                      </div>
                      <button mat-icon-button (click)="viewRevisionDetails(review.id, $event)" class="ml-2">
                        <mat-icon>visibility</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </mat-tab>

        </mat-tab-group>
      </div>
    </div>

    <!-- Selected Inputs List -->
    @if (selectedInputs.length > 0) {
      <div class="row mt-4">
        <div class="col-12">
          <h3 class="mb-3">{{ 'modals.select-inputs.selected-inputs' | translate }} ({{ selectedInputs.length }})</h3>
          <div class="selected-inputs-list">
            @for (input of selectedInputs; track input; let i = $index) {
              <div class="selected-input-chip">
                <mat-icon [class]="'input-icon-' + input.type">{{ getInputIcon(input.type) }}</mat-icon>
                <span class="input-chip-name">{{ input.name }}</span>
                <span class="input-chip-type">{{ getInputTypeLabel(input.type) }}</span>
                <button mat-icon-button class="remove-btn" (click)="removeInput(i)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Action Buttons -->
  <div class="buttons-container container py-5 mb-3">
    <button class="button-primary float-left" mat-button (click)="closeModal()">
      <i class="icon-Backward-arrow-small"></i>
      {{ 'generic.buttons.cancel' | translate }}
    </button>
    <button
      class="button-primary float-right"
      [disabled]="!hasSelections"
      mat-button
      (click)="confirmSelection()">
      <i class="icon-Forward-arrow-small"></i>
      {{ 'modals.select-inputs.confirm-selection' | translate }} ({{ selectedInputs.length }})
    </button>
  </div>
</div>
